import styled from 'styled-components';

// The surface a panel sits on inside a Hive `DrawerLayout` region. The layout
// owns the drawer itself — its width or height, the hairline dividing it from
// the center, the slide, the elevation — so all this adds is what the panels'
// own roots size against: a flex column with a definite height, the way the
// antd drawer's wrapper body used to give them one.
//
// `$inert` follows `ui.disablePointerEvents`, which the app raises while a drag
// is in flight so the panel underneath doesn't swallow the gesture.
const DrawerSurface = styled.div<{ $inert?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  ${({ $inert }) => $inert && 'pointer-events: none;'}
`;

export default DrawerSurface;
